// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();


//Boostrap carousel
jQuery(document).ready(function ($) {
  'use strict';
  // Normalize heights
  function carouselNormalization() {
    window.heights = [], //create empty array to store height values
      window.tallest; //create variable to make note of the tallest slide

    function normalizeHeights() {
      jQuery('.simple_slider .carousel-inner .carousel-item').each(function () { //add heights to array
        window.heights.push(jQuery(this).outerHeight());
      });
      window.tallest = Math.max.apply(null, window.heights); //cache largest value
      jQuery('.simple_slider .carousel-inner .carousel-item').each(function () {
        jQuery(this).css('min-height', tallest + 'px');
      });
    }
    normalizeHeights();

    jQuery(window).on('resize orientationchange', function () {
      window.tallest = 0, window.heights.length = 0; //reset vars
      jQuery('.simple_slider .carousel-inner .carousel-item').each(function () {
        jQuery(this).css('min-height', '0'); //reset min-height
      });
      normalizeHeights(); //run it again 
    });
  }
  jQuery(document).ready(function () {
    carouselNormalization();
  });
});